define('client/client',[], function() {
	var exports = {};
	
	function getScreenWidth() {
		var width = window.screen.width;
		if (exports.isAndroid) {
			width = width / exports.devicePixelRatio;
		}
		return width;
	}
	function getScreenHeight() {
		var height = window.screen.height;
		if (exports.isAndroid) {
			height = height / exports.devicePixelRatio;
		}
		return height;
	}

	function largestScreenDimension() {
		var width = getScreenWidth();
		var height = getScreenHeight();
		return Math.max(width, height);
	}

	if (typeof window === 'undefined') {
		window = {
			navigator: {
				userAgent: 'node'
			},
			devicePixelRatio: 1,
			screen: {
				width: 1,
				height: 1
			}
		};
	}

	var userAgent = window.navigator.userAgent;

	exports.isIPhone = !!userAgent.match(/iPhone|iPod/);
	exports.isIPad = !!userAgent.match(/iPad/);
	exports.isIOS = (exports.isIPhone || exports.isIPad);

	exports.isAndroid = !!userAgent.match(/Android/);
	exports.isWindowsPhone = !!userAgent.match(/IEMobile/);
	
	exports.isKindle = !!userAgent.match(/Silk/);

	exports.isBlackberry = !!userAgent.match(/BB\d\d/);
	exports.isOldBlackberry = !!userAgent.match(/BlackBerry/);
	exports.isPlaybook = !!userAgent.match(/PlayBook/);
	
	exports.isVizio = !!userAgent.match(/Vizio/);
	exports.isGoogleTV = !!userAgent.match(/GoogleTV/);
	exports.isAppleTV = !!userAgent.match(/AppleTV/);
	exports.isTV = (exports.isVizio || exports.isAppleTV || exports.isGoogleTV);

	exports.isMacOS = !!userAgent.match(/Mac OS X/);
	exports.isWindows = !!userAgent.match(/Windows NT/);
	exports.isWindowsRT = !!userAgent.match(/Windows NT[^;]+; ARM;/);

	exports.isWebKit = !!userAgent.match(/WebKit/);
	exports.isGecko = !!userAgent.match(/Gecko/);
	exports.isTrident = exports.isIE = !!userAgent.match(/Trident/);

	exports.isChrome = !!userAgent.match(/Chrome/);

	// provided by WebKit browsers. 1 for regular displays, 2 for pixel doubled displays, but it can be any value.
	exports.devicePixelRatio = window.devicePixelRatio || 1;

	exports.isTouch = ("ontouchmove" in window);

	exports.isRetina = (exports.devicePixelRatio >= 1.5);

	exports.isMobile = (largestScreenDimension() < 1024);
	exports.isTablet = !exports.isMobile && exports.isTouch;
	exports.isDesktop = (!exports.isMobile && !exports.isTablet);

	if (exports.isMobile) {
		exports.typeString = 'mobile';
	} else if (exports.isTablet) {
		exports.typeString = 'tablet';
	} else {
		exports.typeString = 'desktop';
	}

	exports.screen = {
		width: getScreenWidth(),
		height: getScreenHeight()
	};

	if ('onorientationchange' in window) {
		window.addEventListener('onorientationchange', function() {
			exports.screen.width = getScreenWidth();
			exports.screen.height = getScreenHeight();
		});
	}

	return exports;

});
